import { Icon, ImgIcons, Tooltip } from 'imaginarity-react-ui';
import * as PopperJS from "popper.js";
import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from 'services/ApplicationState/ApplicationState';
import { ComponentWithMappedApplicationState } from 'services/ApplicationState/HelperInterfaces';

const mapper = (state: ApplicationState) => ({});

interface LabelInfoProps extends ComponentWithMappedApplicationState<typeof mapper> {
    infoText: string;
    float?: "left" | "right" | undefined;
    icon?: ImgIcons;
    tooltipPosition?: PopperJS.Placement;
    tooltipContent?: JSX.Element;
    warning?: boolean;
}

const LabelInfo = (p: LabelInfoProps) => {
    const { infoText, float, icon, tooltipPosition: position, tooltipContent, warning } = p;

    return (
        <div style={{ float: float ?? "right" }}>
            <Tooltip
                tooltipText={tooltipContent ? "" : infoText}
                noMargin
                position={position ?? 'auto'}
                tooltipContent={tooltipContent}
            >
                <span style={{ width: 30, height: 30, textAlign: "center" }}>
                    <Icon name={icon ?? "info"} color={warning ? "@accentRed" : undefined} />
                </span>
            </Tooltip>
        </div>
    );
}
export default connect(mapper)(LabelInfo);